import { Form } from '@remix-run/react';
import { WebRoutes, cn } from '@theprintbar/shared';
import React, { ButtonHTMLAttributes, SVGAttributes } from 'react';
import { SocialsProvider } from 'remix-auth-socials';

interface SocialButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	callback?: string | null;
	icon: React.FC<SVGAttributes<SVGElement>>;
	iconClassName?: string;
	provider: SocialsProvider;
}

export function SocialButton({
	callback,
	children,
	iconClassName,
	icon: Icon,
	provider,
	disabled,
	className,
	...props
}: SocialButtonProps) {
	return (
		<Form action={`${WebRoutes.OAuth(provider)}${!!callback ? `?callback=${callback}` : ''}`} method="post">
			<button
				className={cn(
					'group rounded-md inline-flex justify-center items-center p-2 border-none hover:disabled:cursor-default hover:disabled:scale-100 focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs font-bold',
					className,
				)}
				disabled={disabled}
				{...props}
			>
				<span className="sr-only">Sign in with {provider}</span>
				<Icon className={cn('w-4 h-4 mr-2', disabled && 'opacity-50', iconClassName)} />

				{children}
			</button>
		</Form>
	);
}
